
import { defineComponent, PropType, computed, getCurrentInstance, ref, onMounted } from 'vue'
import config from '@root/config'
import { checkIntegrationInstalled } from '@/api/marketplace'
const BANNERS = {
    top: {
        theme: 't-light',
        motif: 'dots' as const,
        icon: '⚙️',
        badge: 'Маркетплейс',
        title: 'Выручка может расти быстрее — с экспертной настройкой',
        description:
            'Эксперты Data Heroes настроят сегменты, рассылки и автокасания под ваш салон. Рост выручки гарантирован.',
        ctaLabel: 'Узнать подробнее',
        marketplaceId: config.marketplaceModulesIds[config.buildType].crmSettings,
    },
    hero: {
        theme: 't-ink',
        motif: 'rings' as const,
        icon: '🚀',
        badge: 'Маркетплейс',
        title: 'Бьюти-автопилот: администраторы работают — вы контролируете',
        description:
            'Авто-задачи для команды, мотивация за результат и отслеживание прямо в Data Heroes. Внедрение за 1–2 дня.',
        ctaLabel: 'Узнать подробнее',
        marketplaceId: config.marketplaceModulesIds[config.buildType].beautyAutopilot,
    },
} as const

type BannerVariant = keyof typeof BANNERS

export default defineComponent({
    name: 'DoctorReportPromoBanner',
    props: {
        variant: {
            type: String as PropType<BannerVariant>,
            required: true,
        },
        projectId: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const root = getCurrentInstance()?.proxy
        const bannerConfig = computed(() => BANNERS[props.variant])
        const isVisible = ref(false)

        onMounted(async () => {
            const marketplaceId = bannerConfig.value.marketplaceId
            if (!props.projectId || !marketplaceId) return

            const isInstalled = await checkIntegrationInstalled(props.projectId, marketplaceId)
            isVisible.value = !isInstalled
        })

        function onCtaClick(config) {
            if (!props.projectId || !config.marketplaceId || !root) return
            const targetPath = `/project/${props.projectId}/marketplace/integration/${config.marketplaceId}`
            const { href } = root.$router.resolve(targetPath)
            window.open(href, '_blank', 'noopener,noreferrer')
        }

        return { config: bannerConfig, isVisible, onCtaClick: () => onCtaClick(bannerConfig.value) }
    }
})
